var $ = jQuery.noConflict();

$(function () {
    $(document).ready(function () {
        $(".vimeo-button").on("click", function () {
            var playerId = $(this).siblings(".vimeo-video").attr("id");

            var player = document.getElementById(playerId);
            var data = { method: "play" };
            player.contentWindow.postMessage(JSON.stringify(data), "*");

            $(this).hide();
            $(this).closest(".video-wrap").addClass("interacted");
            $(this).closest(".video-wrap").removeClass("loading");
        });
    });
});

jQuery(function () {
    ////////////////////////////////////////////////
    // START - Video block
    if (jQuery("[data-video]").length) {
        // console.log('is a video');
        // Load the IFrame Player API code asynchronously.
        var tag = document.createElement("script");
        tag.src = "https://player.vimeo.com/api/player.js";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    // END - Video block
    ////////////////////////////////////////////////
});

document.addEventListener("DOMContentLoaded", function () {
    // Function to set the video source by removing old iframe and inserting new one
    const setVideoSource = (thumbnail) => {
        const newVideoUrl = thumbnail.getAttribute("data-video-url");
        const videoCarousel = thumbnail.closest(".video-block");
        const mainVideoContainer = videoCarousel
            ? videoCarousel.querySelector(".video-wrap")
            : null;
        const mainVideoIframe = videoCarousel ? videoCarousel.querySelector("iframe") : null;
        const playButton = videoCarousel ? videoCarousel.querySelector(".video-wrap__play") : null;
        const videoWrap = videoCarousel ? videoCarousel.querySelector(".video-wrap") : null;

        // Show the play button before video starts playing
        if (playButton) {
            playButton.style.display = "block";
            playButton.disabled = false;
        }

        if (videoWrap) {
            videoWrap.classList.remove("interacted");
            videoWrap.classList.add("loading");
        }

        // Update background image of .video-wrap__bg
        const thumbnailImg = thumbnail.querySelector("img");
        const newBgImage = thumbnailImg ? thumbnailImg.src : "";
        const videoWrapBg = videoCarousel.querySelector(".video-wrap__bg");

        if (videoWrapBg && newBgImage) {
            videoWrapBg.style.backgroundImage = `url(${newBgImage})`;
        }

        if (mainVideoContainer) {
            // Remove the existing iframe if present
            if (mainVideoIframe) {
                mainVideoIframe.remove();
            }

            // Create a new iframe for the selected video
            const newIframe = document.createElement("iframe");
            newIframe.setAttribute("frameborder", "0");
            newIframe.setAttribute(
                "allow",
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            );
            newIframe.setAttribute("allowfullscreen", true);
            newIframe.height = "360";
            newIframe.width = "640";

            // Detect if it's YouTube or Vimeo and set the correct src
            if (newVideoUrl.includes("youtube")) {
                const videoId = extractYouTubeVideoId(newVideoUrl);
                newIframe.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&origin=${window.location.origin}&rel=0&modestbranding=1`;
            } else if (newVideoUrl.includes("vimeo")) {
                const videoId = extractVimeoVideoId(newVideoUrl);
                newIframe.src = `https://player.vimeo.com/video/${videoId}`;
            }

            // Insert the new iframe into the container
            mainVideoContainer.appendChild(newIframe);

            // Show the play button again
            if (playButton) {
                playButton.style.display = "block";
            }
        }
    };

    // Helper functions to extract YouTube or Vimeo video IDs
    function extractYouTubeVideoId(url) {
        const regex =
            /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
        const match = url.match(regex);
        return match && match[1] ? match[1] : null;
    }

    function extractVimeoVideoId(url) {
        const regex = /vimeo.*\/(\d+)/i;
        const match = url.match(regex);
        return match && match[1] ? match[1] : null;
    }

    // Function to bind click event to video thumbnails
    const bindThumbnailEvents = () => {
        const videoThumbnails = document.querySelectorAll(".swiper-slide.video-wrap__play");

        videoThumbnails.forEach(function (thumbnail) {
            thumbnail.removeEventListener("click", handleThumbnailClick);
            thumbnail.addEventListener("click", handleThumbnailClick);
        });
    };

    // Event handler for thumbnail click plus add active class
    const handleThumbnailClick = function () {
        // Remove .active from previously active video
        const activeThumbnail = document.querySelector(".video-wrap__play.active");
        if (activeThumbnail) {
            activeThumbnail.classList.remove("active");
        }

        // Add .active to the clicked video
        this.classList.add("active");

        setVideoSource(this);
    };

    // Initial binding of events to the thumbnails
    bindThumbnailEvents();

    // Event handler for play button click
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("video-wrap__play")) {
            const videoCarousel = event.target.closest(".video-block");
            const mainVideoIframe = videoCarousel ? videoCarousel.querySelector("iframe") : null;
            const videoWrap = videoCarousel ? videoCarousel.querySelector(".video-wrap") : null;

            if (mainVideoIframe) {
                const iframeSrc = mainVideoIframe.src;

                if (iframeSrc.includes("youtube")) {
                    const videoId = extractYouTubeVideoId(iframeSrc);
                    if (videoId) {
                        // Create a new YouTube player
                        youtubePlayer = new YT.Player(mainVideoIframe, {
                            videoId: videoId,
                            events: {
                                onReady: function (event) {
                                    if (hasAcceptedAllCookies()) {
                                        console.log("Play");
                                        event.target.playVideo(); // Play the video only after the player is ready
                                        if (videoWrap) {
                                            videoWrap.classList.add("interacted");
                                            videoWrap.classList.remove("loading");
                                        }
                                    }
                                },
                            },
                        });
                    }
                } else if (iframeSrc.includes("vimeo")) {
                    const vimeoVideoId = extractVimeoVideoId(iframeSrc);
                    if (vimeoVideoId) {
                        const iframe = document.querySelector(`iframe[src*="${vimeoVideoId}"]`);
                        if (iframe) {
                            if (videoWrap) {
                                videoWrap.classList.add("interacted");
                                videoWrap.classList.remove("loading");
                            }

                            const vimeoPlayer = new Vimeo.Player(iframe);
                            vimeoPlayer.play();
                        }
                    }
                }

                // Hide the play button after starting the video
                event.target.style.display = "none";
            }
        }
    });
});

const vidSlider = document.querySelectorAll(".video-block--carousel .swiper");
const vidSliderPagination = document.querySelectorAll(".video-carousel-swiper-pagination");
const vidSliderNext = document.querySelectorAll(".video-carousel-swiper-next");
const vidSliderPrev = document.querySelectorAll(".video-carousel-swiper-prev");
const videoSwipers = [];

const updateVideoSliderLayout = (swiperInstance) => {
    if (!swiperInstance) {
        return;
    }

    const viewportWidth = window.innerWidth;
    const isDesktop = viewportWidth >= 1200;
    const isTablet = viewportWidth >= 768;
    const targetDirection = isDesktop ? "vertical" : "horizontal";
    const targetSlidesPerView = isDesktop ? 3 : isTablet ? 3.5 : 2.25;

    if (swiperInstance.params.direction !== targetDirection) {
        swiperInstance.changeDirection(targetDirection, false);
    }

    swiperInstance.params.slidesPerView = targetSlidesPerView;
    swiperInstance.update();
};

for (i = 0; i < vidSlider.length; i++) {
    if (vidSliderPagination[i] && vidSliderNext[i] && vidSliderPrev[i]) {
        // loop through every example of the slider and add a dynamic class
        // then init slider, pagination and nav arrows based on that new dynamic class
        vidSlider[i].classList.add("swiper-" + i);
        vidSliderPagination[i].classList.add("video-carousel-swiper-pagination-" + i);
        vidSliderNext[i].classList.add("video-carousel-swiper-next-" + i);
        vidSliderPrev[i].classList.add("video-carousel-swiper-prev-" + i);

        var initvidSlider = new Swiper(".video-block--carousel .swiper-" + i, {
            grabCursor: true,
            slidesPerView: 2.25,
            direction: "horizontal",
            spaceBetween: 8,
            loop: false,
            autoHeight: false,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                forceToAxis: true,
            },
            // pagination toggle buttons
            pagination: {
                el: ".video-carousel-swiper-pagination-" + i,
                clickable: true,
            },
            // navigation arrows
            navigation: {
                nextEl: ".video-carousel-swiper-next-" + i,
                prevEl: ".video-carousel-swiper-prev-" + i,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 8,
                },
                1200: {
                    spaceBetween: 24,
                    slidesPerView: 3,
                    direction: "vertical",
                },
            },
        });

        videoSwipers.push(initvidSlider);
        updateVideoSliderLayout(initvidSlider);
    }
}

let videoSliderResizeRaf = null;
window.addEventListener("resize", function () {
    if (videoSliderResizeRaf) {
        window.cancelAnimationFrame(videoSliderResizeRaf);
    }

    videoSliderResizeRaf = window.requestAnimationFrame(function () {
        videoSwipers.forEach(function (swiperInstance) {
            updateVideoSliderLayout(swiperInstance);
        });
    });
});
